import React from 'react';
import FileSaver from 'file-saver';
import moment from 'moment';
import { v4 as createUUID } from 'uuid';
import { removeSelectedFromList, wakeUpDevices } from '../../../store/bulk-device-flash/actions';
import { PreFlashRecord } from '../../../store/bulk-device-flash/types';
import { VirtualTableHeadCell } from '../../virtualized-table/types';
import QueueFile from '../queue-file';
import { preTableHeadCells } from '../table/head-cells';

export interface BulkOption {
  title: string;
  value: number;
  action?: Function;
  popover?: React.FC | React.ReactElement;
}

export const preTableBulkOptions = (
  rows: PreFlashRecord[],
  closePopover: Function,
  dispatch: Function,
): BulkOption[] => [
  {
    title: 'Queue Files',
    value: 1,
    popover: <QueueFile rows={rows} closePopover={closePopover} />,
  },
  {
    title: 'Wakeup',
    value: 2,
    action: () => {
      const UUID = createUUID();
      const selectRowsAsDevicesToWake = rows.map((row) => ({
        make: row.make,
        serialNumber: row.serialNumber,
        transactionId: UUID,
        deviceKey: row.deviceKey
      }));
      dispatch(wakeUpDevices(selectRowsAsDevicesToWake));
    },
  },
  {
    title: 'Remove From List',
    value: 3,
    action: () => {
      dispatch(removeSelectedFromList(rows));
    },
  },
  {
    title: 'Export',
    value: 4,
    action: () => {
      const headerString = `${preTableHeadCells.map(
        (headerCell: VirtualTableHeadCell) => `${headerCell.Header}`,
      )}\n`;
      const rowAsString = rows.map(
        (row: any) =>
          `${preTableHeadCells.map(
            (headerCell: VirtualTableHeadCell) => `${row[headerCell.accessor] || ''}`,
          )}\n`,
      );
      const blob = new Blob([`${headerString}${rowAsString.join('')}`], {
        type: 'text/plain;charset=utf-8',
      });
      FileSaver.saveAs(blob, `Export_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`);
    },
  },
];
